import React from 'react';
import { Link } from 'react-router-dom';
import Header from '../components/layout/Header';
import Footer from '../components/layout/Footer';
import { Button } from '../components/ui/button';
import { useLanguage } from '../context/LanguageContext';
import { BarChart3, Palette, HeadphonesIcon } from 'lucide-react';

const MarketingBrandingPage = () => {
  const { t } = useLanguage();

  const services = [
    {
      titleKey: 'emailMarketingTitle',
      descKey: 'emailMarketingDesc',
      image: 'https://images.unsplash.com/photo-1557200134-90327ee9fafa?w=600&q=80'
    },
    {
      titleKey: 'socialMediaMarketingTitle',
      descKey: 'socialMediaMarketingDesc',
      image: 'https://images.unsplash.com/photo-1611162618071-b39a2ec055fb?w=600&q=80'
    },
    {
      titleKey: 'brandingTitle',
      descKey: 'brandingDesc',
      image: 'https://customer-assets.emergentagent.com/job_2c966088-8797-43ff-a34e-a4775ed9024e/artifacts/vopua7to_TBL.jpg'
    },
    {
      titleKey: 'aiBotsTitle',
      descKey: 'aiBotsDesc',
      image: 'https://images.unsplash.com/photo-1485827404703-89b55fcc595e?w=600&q=80'
    }
  ];

  const whyChooseUs = [
    {
      titleKey: 'dataDrivenStrategy',
      descKey: 'dataDrivenStrategyDesc',
      icon: BarChart3
    },
    {
      titleKey: 'creativeExcellence',
      descKey: 'creativeExcellenceDesc',
      icon: Palette
    },
    {
      titleKey: 'fullServiceSupport',
      descKey: 'fullServiceSupportDesc',
      icon: HeadphonesIcon
    }
  ];

  return (
    <div className="min-h-screen">
      <Header />
      
      {/* Page Content */}
      <section className="py-16 md:py-24 bg-white">
        <div className="container mx-auto px-4">
          <div className="max-w-4xl mx-auto text-center mb-16">
            <h1 className="font-montserrat-bold text-3xl md:text-4xl lg:text-5xl text-[#0b004c] mb-6">
              {t('marketingBrandingTitle')}
            </h1>
            <p className="font-montserrat text-base md:text-lg text-[#6a6a6a] mb-4">
              {t('marketingBrandingDesc1')}
            </p>
            <p className="font-montserrat text-base md:text-lg text-[#6a6a6a]">
              {t('marketingBrandingDesc2')}
            </p>
          </div>

          {/* Services Grid */}
          <div className="grid grid-cols-1 md:grid-cols-2 gap-8 mb-16">
            {services.map((service, index) => (
              <div key={index} className="bg-gray-50 rounded-lg overflow-hidden shadow-md hover:shadow-xl transition-shadow duration-300">
                <div className="aspect-video overflow-hidden">
                  <img 
                    src={service.image} 
                    alt={t(service.titleKey)}
                    className="w-full h-full object-cover hover:scale-105 transition-transform duration-500"
                  />
                </div>
                <div className="p-6">
                  <h3 className="font-montserrat-bold text-xl text-[#0b004c] mb-3">
                    {t(service.titleKey)}
                  </h3>
                  <p className="font-montserrat text-[#6a6a6a]">
                    {t(service.descKey)}
                  </p>
                </div>
              </div>
            ))}
          </div>

          {/* Why Choose Us Section */}
          <div className="bg-[#0b004c] rounded-xl p-8 md:p-12">
            <h2 className="font-montserrat-bold text-2xl md:text-3xl text-white text-center mb-12">
              {t('whyChooseMarketing')}
            </h2>
            <div className="grid grid-cols-1 md:grid-cols-3 gap-8">
              {whyChooseUs.map((item, index) => {
                const IconComponent = item.icon;
                return (
                  <div key={index} className="text-center">
                    <div className="flex justify-center mb-4">
                      <IconComponent className="w-12 h-12 text-white" />
                    </div>
                    <h3 className="font-montserrat-bold text-white text-lg mb-2">{t(item.titleKey)}</h3>
                    <p className="font-montserrat text-white/70 text-sm">{t(item.descKey)}</p>
                  </div>
                );
              })}
            </div>
          </div>
        </div>
      </section>

      {/* CTA Section */}
      <section className="py-16 bg-gray-100">
        <div className="container mx-auto px-4 text-center">
          <h2 className="font-montserrat-bold text-2xl md:text-3xl text-[#0b004c] mb-4">
            {t('readyElevateBrand')}
          </h2>
          <p className="font-montserrat text-[#6a6a6a] mb-8 max-w-2xl mx-auto">
            {t('marketingCTADesc')}
          </p>
          <Link to="/contact">
            <Button className="bg-[#0b004c] hover:bg-[#1a0066] text-white px-8 py-3 font-montserrat-bold">
              {t('getStarted')}
            </Button>
          </Link>
        </div>
      </section>

      <Footer />
    </div>
  );
};

export default MarketingBrandingPage;
